export default __webpack_public_path__ + "static/media/folder.ce4d3d7c.svg";